import { PTPDetails } from "@portal/BaseComponents/Activites/PromiseToPay/PTPDetailsView/PTPDetails";
import { InvoiceDetailsView } from "@portal/BaseComponents/DetailsView/InvoiceDetailsView/InvoiceDetailsView";
import { PTPList } from "@portal/Components/Portal/PotalTabs/PTPs/PTPList";
import { useFormats } from "@portal/hooks/use-formats";
import { Provider } from "jotai";

function PTPListsPage() {
  const { extra } = useFormats();
  return (
    <>
      <Provider>
        {/* <PTPFilters /> */}
        <PTPList extra={extra} />
      </Provider>
      <PTPDetails />
      <InvoiceDetailsView />
    </>
  );
}

export { PTPListsPage };
